import {createStyles, Theme} from '@material-ui/core/styles';
import * as colors from 'assets/theme/colors';

export default createStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '& .MuiCardHeader-root': {
            flexDirection: 'column-reverse',
            alignItems: 'flex-start',
            '& .MuiCardHeader-action': {
                marginLeft: '-12px',
            },
        },
    },
    body: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0, 2, 0, 2),
        position: 'relative',
        minHeight: '200px',
        display: 'flex',
    },
    title: {
        color: '#393832',
        fontWeight: 'bold',
        fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
    },
    description: {
        color: '#393832',
        fontWeight: 'normal',
        fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
    },
    legend: {
        color: '#393832',
        fontWeight: 'normal',
        textAlign: 'center',
        fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
    },
    siganturePad: {
        backgroud: '#FFFFFF',
        boxShadow: '0px 4px 8px rgba(104, 107, 128, 0.3)',
        borderRadius: '4px',
        minHeight: '11rem',
        width: '100%',
        margin: '0 auto',
    },
    signPadActions: {
        float: 'right',
    },
    signCanvas: {
        width: '100%',
        height: '100%',
        minHeight: '11rem',
        borderBottom: `1px solid ${colors.secondary.A02}`,
    },
    baseStyle: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        borderWidth: 1,
        borderRadius: 2,
        borderColor: '#000',
        borderStyle: 'dashed',
        backgroundColor: '#fff',
        color: '#666',
        outline: 'none',
        transition: 'border .24s ease-in-out',
    },
    filesList: {
        color: '#393832',
        fontWeight: 'normal',
        listStyle: 'none',
    },
    iconLabel: {
        display: 'flex',
        alignItems: 'center',
    },
    camTitle: {
        color: '#393832',
        letterSpacing: '0.15px',
        fontSize: '24px',
        lineHeiht: '32px',
        fontWeight: 'normal',
        textAlign: 'center',
    },
    camDescription: {
        fontWeight: 'normal',
        textAlign: 'center',
    },
    button: {
        backgroundColor: '#194166',
        color: 'white',
        justifyContent: 'center',
        margin: '0 auto',
    },
    takeAgainButton: {
        backgroundColor: '#222222',
        color: 'white',
        justifyContent: 'center',
        margin: '0 auto',
    },
}));
